var map = {
	"./additionalBuy.png": 29018,
	"./address-default.png": 96139,
	"./deposit.png": 11257,
	"./groupon.png": 46025,
	"./inEmployeeGo.png": 90460,
	"./live.png": 82869,
	"./offlineDelivery.png": 90766,
	"./quickBuy.png": 87988,
	"./vipFirst.png": 72646
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 48736;